export default __webpack_public_path__ + "static/media/equipo_bg.dc8c7a8f.svg";